/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightDownIcon20Light = forwardRef('ArrowDUturnRightDownIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M15 9.5a6.5 6.5 0 1 0-13 0v4a.5.5 0 0 0 1 0v-4a5.5 5.5 0 1 1 11 0v6.34a.76.76 0 0 1-.058-.057l-3.57-3.967a.5.5 0 0 0-.744.668l3.571 3.968a1.75 1.75 0 0 0 2.602 0l3.57-3.968a.5.5 0 0 0-.743-.668l-3.57 3.967a.776.776 0 0 1-.058.058V9.5Z" })));
});
